export default __webpack_public_path__ + "static/media/benguet_province_seal.8a148fa1.png";